// outline-none + focus-visible: keep a ring for real keyboard focus only.
const FOCUS_RING =
  'outline-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[var(--sidebar-accent)]';

export const SIDEBAR_MENU_ITEM_BASE = `group flex items-center gap-3 py-[calc(0.55rem+3px)] min-h-0 min-w-0 text-[15px] leading-[1.3] font-normal font-sans transition-colors ltr:border-l-[3px] rtl:border-r-[3px] px-3 w-full text-start text-n-slate-12 ${FOCUS_RING}`;

export const SIDEBAR_MENU_ITEM_ACTIVE =
  'border-[var(--sidebar-accent)] bg-[var(--sidebar-active-bg)] text-[var(--sidebar-accent)]';

export const SIDEBAR_MENU_ITEM_ACTIVE_BG = 'bg-[var(--sidebar-active-bg)]';
export const SIDEBAR_MENU_ITEM_ACTIVE_TEXT = 'text-[var(--sidebar-accent)]';

export const SIDEBAR_MENU_ITEM_INACTIVE =
  'border-transparent hover:bg-[var(--sidebar-hover-bg)] hover:text-[var(--sidebar-accent)]';

export const SIDEBAR_SUBMENU_ITEM_BASE = `flex min-h-0 items-center gap-2 px-4 py-[calc(0.4rem+3px)] text-[13px] leading-[1.3] font-normal font-sans transition-colors ${FOCUS_RING}`;

export const SIDEBAR_MENU_ICON_ACTIVE = 'text-[var(--sidebar-accent)]';

export const SIDEBAR_MENU_ICON_INACTIVE =
  'text-n-slate-12 dark:text-n-slate-11 group-hover:text-[var(--sidebar-accent)]';

export const SIDEBAR_DIVIDER =
  'list-none h-0 my-[0.65rem] mx-3 border-0 border-t border-n-weak';
